import { forwardRef } from 'react'
import type {
  PolymorphicRefFunction,
  StaticRefFunction,
  StaticRefFunctionWithDefinedRef
} from './global-types/index'

export const polymorphicForwardRef = forwardRef as PolymorphicRefFunction
export const staticForwardRef = forwardRef as StaticRefFunction
export const staticForwardDefinedRef =
  forwardRef as StaticRefFunctionWithDefinedRef
